import qrSvgRaw from "bundle-text:./eu-legal-guarantee-qr.svg"

const euLegalGuaranteeUrl =
  "https://europa.eu/youreurope/citizens/consumers/shopping/guarantees/index_sv.htm"

const widgetClass = "reach-svd-checkout-guarantee"

const qrSvg = qrSvgRaw.replace(/<\?xml[^>]*>/, "").replace(/<!DOCTYPE[^>]*>/, "")

function createGuaranteeLink(): HTMLAnchorElement {
  const link = document.createElement("a")
  link.className = widgetClass
  link.href = euLegalGuaranteeUrl
  link.target = "_blank"
  link.rel = "noopener noreferrer"
  link.hidden = true
  link.setAttribute("aria-label", "Lagstadgad garanti (EU)")
  link.innerHTML = `
    ${qrSvg}
    <span>Lagstadgad garanti (EU)</span>
  `
  return link
}

function checkoutIsStacked(cart: HTMLElement): boolean {
  const sidebar = cart.querySelector(".ec-cart__sidebar")
  const body = cart.querySelector(".ec-cart__body")
  if (!(sidebar instanceof HTMLElement) || !(body instanceof HTMLElement)) {
    return true
  }

  return body.getBoundingClientRect().top >= sidebar.getBoundingClientRect().bottom - 8
}

function alignBelowNastaLine(link: HTMLElement, host: HTMLElement) {
  link.style.marginTop = "0px"

  const caption = host.querySelector(".ec-cart-step--order-confirmation .ec-cart-step__body")
  const label = link.querySelector("span")
  if (!(caption instanceof HTMLElement) || !(label instanceof HTMLElement)) {
    return
  }

  const hostTop = host.getBoundingClientRect().top
  const linkBox = link.getBoundingClientRect()
  if (Math.abs(linkBox.top - hostTop) > 12) {
    return
  }

  const labelOffset = label.getBoundingClientRect().top - linkBox.top
  const offset = caption.getBoundingClientRect().top - hostTop - labelOffset
  link.style.marginTop = `${Math.max(0, Math.round(offset))}px`
}

function purchasePage(): HTMLElement | null {
  const page = document.querySelector(".ec-store__cart-page, .ec-store__checkout-page")
  if (!(page instanceof HTMLElement)) {
    return null
  }

  const cart = page.querySelector(".ec-cart")
  return cart instanceof HTMLElement ? cart : page
}

export function initSvdCheckoutGuarantee() {
  const store = document.querySelector("#store")
  if (!(store instanceof HTMLElement)) {
    return
  }

  const existing = document.querySelector(`.${widgetClass}`)
  const link = existing instanceof HTMLAnchorElement ? existing : createGuaranteeLink()

  const sync = () => {
    const page = purchasePage()
    if (page == null) {
      link.hidden = true
      link.style.marginTop = "0px"
      link.classList.remove(`${widgetClass}--stacked`)
      if (link.parentElement !== store) {
        store.appendChild(link)
      }
      return
    }

    link.hidden = false
    const cart = page.classList.contains("ec-cart") ? page : null
    const steps = cart?.querySelector(".ec-cart__steps")
    const stacked = cart != null && checkoutIsStacked(cart)

    if (stacked && steps instanceof HTMLElement) {
      link.style.marginTop = ""
      link.classList.add(`${widgetClass}--stacked`)
      if (link.previousElementSibling !== steps) {
        steps.insertAdjacentElement("afterend", link)
      }
      return
    }

    link.classList.remove(`${widgetClass}--stacked`)
    if (link.parentElement !== page) {
      page.appendChild(link)
    }
    if (cart != null) {
      alignBelowNastaLine(link, cart)
    }
  }

  let scheduled = false
  const scheduleSync = () => {
    if (scheduled) {
      return
    }
    scheduled = true
    requestAnimationFrame(() => {
      scheduled = false
      sync()
    })
  }

  const observe = () => {
    new MutationObserver(scheduleSync).observe(store, { childList: true, subtree: true })
    scheduleSync()
  }

  const whenEcwidPageApiReady = (callback: () => void) => {
    if (window.Ecwid?.OnPageLoaded) {
      callback()
      return
    }

    const startedAt = Date.now()
    const intervalId = window.setInterval(() => {
      if (window.Ecwid?.OnPageLoaded) {
        window.clearInterval(intervalId)
        callback()
        return
      }

      if (Date.now() - startedAt > 15_000) {
        window.clearInterval(intervalId)
      }
    }, 50)
  }

  whenEcwidPageApiReady(() => {
    window.Ecwid?.OnPageLoaded.add(scheduleSync)
    window.Ecwid?.OnPageSwitch.add(() => {
      window.setTimeout(scheduleSync, 50)
      window.setTimeout(scheduleSync, 300)
    })
    observe()
    window.addEventListener("resize", scheduleSync)
  })
}
